import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/` — Spec #151 Phase 1 (T-F).
 *
 * 無条件で `/lucid` に redirect する。Self Lucid をアプリの唯一の
 * "ホーム" に固定するため、`beforeLoad` で TanStack Router の
 * `redirect()` を投げて component が描画される前に遷移を確定させる。
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/lucid' });
  },
});
